import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/results.css";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import QuestionRenderer from "../assessment/QuestionRenderer"; // ✅ reuse your renderer

const Results = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { score, answers, questions } = location.state || {};
  const [filter, setFilter] = React.useState("all");

  if (score === undefined || !answers || !questions || questions.length === 0) {
    return (
      <div className="results-container">
        <h1>Results Unavailable</h1>
        <p>Error: No assessment data found.</p>
        <button className="button button-primary" onClick={() => navigate("/assessment-setup")}>
          Return to Setup
        </button>
      </div>
    );
  }

  const filteredQuestions = questions.filter((question) => {
    const userAnswer = answers[question.id] || "No Answer";
    const isCorrect = userAnswer === question.answerChoices.find(choice => choice.isCorrect)?.choiceText;
    if (filter === "correct") return isCorrect;
    if (filter === "incorrect") return !isCorrect;
    return true;
  });

  return (
    <div className="results-container">
      <h1>Assessment Results</h1>

      <div className="score-row">
        <p className="score-text">
          <strong>Your Score:</strong> {score} / {questions.length}
        </p>
        <div className="score-filters">
          <span className={`filter-icon ${filter === "all" ? "active" : ""}`} title="Show All" onClick={() => setFilter("all")}>
            <VisibilityIcon />
          </span>
          <span className={`filter-icon ${filter === "correct" ? "active" : ""}`} title="Correct Answers Only" onClick={() => setFilter("correct")}>
            <CheckCircleIcon />
          </span>
          <span className={`filter-icon ${filter === "incorrect" ? "active" : ""}`} title="Incorrect Answers Only" onClick={() => setFilter("incorrect")}>
            <CancelIcon />
          </span>
        </div>
      </div>

      <div className="review-list">
        {filteredQuestions.map((question, index) => {
          const userAnswer = answers[question.id] || "No Answer";
          const isCorrect = userAnswer === question.answerChoices.find(choice => choice.isCorrect)?.choiceText;

          return (
            <div key={question.id} className={`review-item ${isCorrect ? "correct" : "incorrect"}`}>
              <div className="question-panel">
                <QuestionRenderer question={question} index={index} />

                <p>
                  <span className="label">Your Answer:</span>{" "}
                  <span className="user-answer">{userAnswer}</span>
                </p>
                <p>
                  <span className="label">Correct Answer:</span>{" "}
                  <span className="correct-answer">
                    {
                      question.answerChoices.find(choice => choice.isCorrect)?.choiceText
                      || "Not specified"
                    }
                  </span>
                </p>
              </div>

              {(() => {
                const userAnswer = answers[question.id];
                const userChoice = question.answerChoices?.find(
                  choice => choice.choiceText?.trim() === userAnswer?.trim()
                );

                return userChoice?.explanation ? (
                  <div className="explanation-panel">
                    <strong>Explanation:</strong>
                    <span className="explanation">
                      {
                        question.answerChoices.find(choice => choice.isCorrect)?.explanation
                        || "No explanation provided"
                      }
                    </span>
                  </div>
                ) : null;
              })()}

            </div>
          );
        })}
      </div>

      <div className="results-buttons">
        <button className="button button-primary" onClick={() => navigate("/assessments")}>
          Retake Assessment
        </button>
        <button className="button button-secondary" onClick={() => navigate("/home")}>
          Return Home
        </button>
      </div>
    </div>
  );
};

export default Results;
